/**
 * @function apiFetch
 * @description Fetches data from an API endpoint
 *
 * @async
 * @return {void}
 */
export default async function apiFetch(
    endpoint,
    method,
    data = null,
    json = false
) {
    const headers = new Headers({ 'X-Requested-With': 'XMLHttpRequest' });
    const args = { method, headers };

    if (json) {
        headers.set('Content-Type', 'application/json');
    }

    if (method !== 'GET') {
        args.body = json ? JSON.stringify(data) : data;
    }

    try {
        const response = await fetch(endpoint, args);

        if (response.ok) {
            const data = await response.json();

            return data;
        } else {
            throw response.statusText;
        }
    } catch (error) {
        console.error(error);
        return { error: true, message: error };
    }
}
